module.exports = __webpack_public_path__ + "img/banner.4f2e260d.jpg";